<template>
    <div class="tw-relative">
        <div @click="isActive = !isActive" v-if="!loading" :class="[status.color]" class="tw-rounded tw-w-[90px] tw-text-center tw-text-xs tw-px-2 tw-py-1 tw-mx-auto tw-cursor-pointer tw-border tw-border-solid tw-border-transparent hover:tw-border-primary-300 tw-duration-200">
            {{ $t(status.name) }}
        </div>

        <div v-if="loading" class="tw-rounded tw-text-xs tw-w-[80px] tw-flex tw-items-center tw-justify-center tw-px-4 tw-py-1 tw-mx-auto tw-cursor-pointer tw-border tw-border-solid tw-border-transparent tw-bg-gray-100">
            <icon icon="eos-icons:three-dots-loading" class=" tw-text-gray-500 tw-text-lg" />
        </div>

        <transition
      class="tw-duration-200"
      enter-from-class="tw-translate-y-[15px]  tw-opacity-0"
      leave-to-class="tw-translate-y-[15px]  tw-opacity-0"
    >
      <div v-if="isActive">
          <div class="tw-absolute tw-translate-y-2 tw-left-0 tw-w-full tw-h-fit tw-p-2 tw-bg-white tw-rounded tw-min-w-[100px] tw-border tw-border-solid tw-border-gray-100 tw-shadow-sm">
              <div class="tw-flex tw-items-center tw-gap-2 tw-flex-col ">
                  <button v-for="status in sourcing_statuses" 
                  class="tw-whitespace-nowrap tw-px-1 tw-py-0.5 tw-rounded tw-text-xs tw-w-full tw-ring tw-ring-transparent hover:tw-ring-primary-300 tw-duration-200"
                  :class="[
                      status.color,
                      status.value === selectedStatus ? 'tw-ring !tw-ring-primary-200' : ''
                      ]" :key="status.value" @click="onStatusChange(status.value)">
                      {{ $t(status.name) }}
                  </button>
              </div>
          </div>
      </div>
    </transition>

    </div>
</template>

<script setup>
import { statuses } from '@/config/sourcing';
import { computed, defineProps, ref, inject } from 'vue';
import { useI18n } from "vue-i18n";
import { updateStatus } from '@/api/sourcings';
import useAlert from "@/composables/useAlert";

const isActive = ref(false)
const loading = ref(false)
const i18n = useI18n();
const sourcing_statuses = computed(() => statuses.filter(c => c.value !== 'completed').map(c => ({ ...c, label: i18n.t(c.name) })))
const updateSourcing = inject('updateSourcing')
const props = defineProps({
    sourcing: {
        type: Object,
        required: true,
    },
})
const selectedStatus = ref(props.sourcing.status)
const status = computed(() => statuses.find(c => c.value === props.sourcing.status))

const onStatusChange = async (status) => {
    loading.value = true
    isActive.value = false
    
    await updateStatus(props.sourcing.id, status)

    selectedStatus.value = status

    loading.value = false

    useAlert('Status updated successfully', 'success')
    const sourcing = {
        ...props.sourcing,
        status: status
    }
    updateSourcing(sourcing)
}

</script>

<style></style>